<template>
  <div id="trial-to-do-list">
    <div class="trial-list-header">
      <h1>{{ remaining_days }}</h1>
      <h3>Days Left in Your Free 30-Day Trial</h3>
      <img
        v-if="remaining_days > 22"
        src="/images/Trial_Start.png"
        alt="DataCast"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 14 && remaining_days < 23"
        src="/images/Trial_7days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 7 && remaining_days < 15"
        src="/images/Trial_15days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 0 && remaining_days < 8"
        src="/images/Trial_23days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days < 1"
        src="/images/Trial_END.png"
        alt="Trends Report"
        class="trial-slider"
      />
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div
            class="col-large-6"
            v-bind:class="
              bookWalkthroughIsHidden || book_walkthrough ? 'd-none' : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                bookWalkthroughIsHidden
                  ? 'tl-complete'
                  : '' || book_walkthrough
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Book a Walkthrough</label>
              <p>
                Schedule a walkthrough with one of our Client Relations
                Specialists to explore all the features and capabilities of your
                subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  bookWalkthroughIsHidden
                    ? 'tl-button-complete'
                    : '' || book_walkthrough
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  target="preview"
                  v-on:click="bookWalkthrough"
                >
                  Book Now
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              reviewMethodologyIsHidden || review_methodology ? 'd-none' : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                reviewMethodologyIsHidden
                  ? 'tl-complete'
                  : '' || review_methodology
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Review Methodology</label>
              <p>
                Learn more about Rates-of-Change, leading indicator analysis,
                and more, by visiting our methodology page.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  reviewMethodologyIsHidden
                    ? 'tl-button-complete'
                    : '' || review_methodology
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  target="_blank"
                  v-on:click="reviewMethodology"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              viewTutorialVideoIsHidden || view_tutorial_video ? 'd-none' : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                viewTutorialVideoIsHidden
                  ? 'tl-complete'
                  : '' || view_tutorial_video
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>View Tutorial Video</label>
              <p>
                View our onDemand portal tutorial video to learn all about the
                ins and outs of your online subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  viewTutorialVideoIsHidden
                    ? 'tl-button-complete'
                    : '' || view_tutorial_video
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  target="preview"
                  v-on:click="viewTutorialVideo"
                >
                  watch now
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              howToArticleVideoIsComplete && saveArticlesIsComplete
                ? 'd-none'
                : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                howToArticleVideoIsComplete && saveArticlesIsComplete
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Save Your Favorite Articles</label>
              <p>
                Which articles are you most interested in? Peruse your
                subscription and use the “star” icon to save your favorites.
              </p>
              <div
                class="tl-double-button"
                v-bind:class="
                  howToArticleVideoIsComplete && saveArticlesIsComplete
                    ? 'tl-button-complete'
                    : ''
                "
              >
                <a
                  class="button-blue"
                  v-bind:class="
                    howToArticleVideoIsComplete || how_to_article_video
                      ? 'article-complete'
                      : ''
                  "
                  href="/trendsreport/trial-list/save-favorite-faq"
                  target="_blank"
                  v-on:click="articleHowToVideo"
                >
                  {{ howToArticleVideoText }}
                </a>
                <a
                  class="button-blue"
                  href="/trendsreport/all-articles"
                  v-bind:class="
                    saveArticlesClicked || saveArticlesIsComplete
                      ? 'article-complete'
                      : ''
                  "
                  v-on:click="saveArticles"
                  v-on:load="checkIfFavorite"
                >
                  {{ saveFavorite }}
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="downloadAppIsHidden || download_app ? 'd-none' : ''"
          >
            <div
              class="trial-box"
              v-bind:class="
                downloadAppIsHidden
                  ? 'tl-complete'
                  : '' || download_app
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Download the ITR onDemand App</label>
              <p>
                Ready to make the most of your subscription, anywhere and at any
                time? Download our app on your smart device to get started.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  downloadAppIsHidden
                    ? 'tl-button-complete'
                    : '' || download_app
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  target="preview"
                  v-on:click="downloadApp"
                >
                  Completed
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              howToNotificationsVideoIsComplete && getNotificationsIsComplete
                ? 'd-none'
                : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                howToNotificationsVideoIsComplete && getNotificationsIsComplete
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Sign up for Notifications</label>
              <p>
                Don’t miss out on updates for your favorite articles - use the
                “bell” icon to receive notifications when specific articles are
                updated.
              </p>
              <div
                class="tl-double-button"
                v-bind:class="
                  howToNotificationsVideoIsComplete &&
                  getNotificationsIsComplete
                    ? 'tl-button-complete'
                    : ''
                "
              >
                <a
                  class="button-blue"
                  v-bind:class="
                    howToNotificationsVideoIsComplete ||
                    how_to_notification_video
                      ? 'article-complete'
                      : ''
                  "
                  href="/trendsreport/trial-list/save-notification-faq"
                  target="_blank"
                  v-on:click="howToNotificationsVideo"
                >
                  {{ howToNotificationVideoText }}
                </a>
                <a
                  class="button-blue"
                  href="/trendsreport/all-articles"
                  v-bind:class="
                    saveNotificationsClicked || getNotificationsIsComplete
                      ? 'article-complete'
                      : ''
                  "
                  v-on:click="getNotifications"
                  v-on:load="checkIfFavorite"
                >
                  {{ saveNotification }}
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-large-12"
            v-bind:class="
              (coreClicked || core_dashboard) &&
              (financialClicked || financial_dashboard) &&
              (constructionClicked || construction_dashboard) &&
              (manufacturingClicked || manufacturing_dashboard)
                ? 'd-none'
                : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                (coreClicked || core_dashboard) &&
                (financialClicked || financial_dashboard) &&
                (constructionClicked || construction_dashboard) &&
                (manufacturingClicked || manufacturing_dashboard)
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Review Core Dashboards</label>
              <p>
                Need a quick overview of industry trends over the next three
                years? Our “at-a-glance” tables for each major sector feature
                economic insights and Business Cycle Phase projections for the
                near future.
              </p>
              <div
                class="tl-double-button"
                v-bind:class="
                  (coreClicked || core_dashboard) &&
                  (financialClicked || financial_dashboard) &&
                  (constructionClicked || construction_dashboard) &&
                  (manufacturingClicked || manufacturing_dashboard)
                    ? 'tl-button-complete'
                    : ''
                "
              >
                <a
                  class="button-blue"
                  v-bind:class="
                    coreClicked || core_dashboard ? 'article-complete' : ''
                  "
                  target="preview"
                  v-on:click="trCoreDashboard"
                >
                  {{ trCoreDashboardText }}
                </a>
                <a
                  class="button-blue"
                  v-bind:class="
                    financialClicked || financial_dashboard
                      ? 'article-complete'
                      : ''
                  "
                  v-on:click="trFinancialDashboard"
                >
                  {{ trFinancialDashboardText }}
                </a>
                <a
                  class="button-blue"
                  v-bind:class="
                    constructionClicked || construction_dashboard
                      ? 'article-complete'
                      : ''
                  "
                  target="preview"
                  v-on:click="trConstructionDashboard"
                >
                  {{ trConstructionDashboardText }}
                </a>
                <a
                  class="button-blue"
                  v-bind:class="
                    manufacturingClicked || manufacturing_dashboard
                      ? 'article-complete'
                      : ''
                  "
                  v-on:click="trManufacturingDashboard"
                >
                  {{ trManufacturingDashboardText }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-4 screen-help-col"
        v-bind:class="
          (bookWalkthroughIsHidden &&
            reviewMethodologyIsHidden &&
            viewTutorialVideoIsHidden &&
            howToArticleVideoIsComplete &&
            saveArticlesIsComplete &&
            downloadAppIsHidden &&
            howToNotificationsVideoIsComplete &&
            getNotificationsIsComplete) ||
          (book_walkthrough &&
            review_methodology &&
            view_tutorial_video &&
            howToArticleVideoIsComplete &&
            saveArticlesIsComplete &&
            download_app &&
            howToNotificationsVideoIsComplete &&
            getNotificationsIsComplete)
            ? 'screen-help-col-false'
            : ''
        "
      >
        <div class="trial-help-box">
          <img src="/images/FAQ.png" alt="Help" class="trial-faq" />
          <p class="trial-help-text">Stuck? Need help?</p>
          <p>
            <a href="https://faq.itreconomics.com/en/trends-report">
              Click here
            </a>
            to check out our Trends Report™ FAQ.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div
            class="col-large-6"
            v-bind:class="
              bookWalkthroughIsHidden || book_walkthrough ? 'd-block' : 'd-none'
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                bookWalkthroughIsHidden || book_walkthrough ? 'tl-complete' : ''
              "
            >
              <label>Book a Walkthrough</label>
              <p>
                Schedule a walkthrough with one of our Client Relations
                Specialists to explore all the features and capabilities of your
                subscription.
              </p>
              <div
                class="tl-hidden"
                v-bind:class="
                  bookWalkthroughIsHidden || book_walkthrough
                    ? 'tl-complete'
                    : ''
                "
              >
                <p
                  v-bind:class="
                    bookWalkthroughIsHidden || book_walkthrough
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              reviewMethodologyIsHidden || review_methodology
                ? 'd-block'
                : 'd-none'
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                reviewMethodologyIsHidden || review_methodology
                  ? 'tl-complete'
                  : '' || review_methodology
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Review Methodology</label>
              <p>
                Learn more about Rates-of-Change, leading indicator analysis,
                and more, by visiting our methodology page.
              </p>
              <div
                class="tl-hidden"
                v-bind:class="
                  reviewMethodologyIsHidden || review_methodology
                    ? 'tl-complete'
                    : ''
                "
              >
                <p
                  v-bind:class="
                    reviewMethodologyIsHidden || review_methodology
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              viewTutorialVideoIsHidden || view_tutorial_video
                ? 'd-block'
                : 'd-none'
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                viewTutorialVideoIsHidden || view_tutorial_video
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>View Tutorial Video</label>
              <p>
                View our onDemand portal tutorial video to learn all about the
                ins and outs of your online subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  viewTutorialVideoIsHidden || view_tutorial_video
                    ? 'tl-button-complete'
                    : ''
                "
              >
                <a
                  class="button-blue"
                  target="preview"
                  v-on:click="viewTutorialVideo"
                >
                  watch now
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  viewTutorialVideoIsHidden || view_tutorial_video
                    ? 'tl-complete'
                    : ''
                "
              >
                <p
                  v-bind:class="
                    viewTutorialVideoIsHidden || view_tutorial_video
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              howToArticleVideoIsComplete && saveArticlesIsComplete
                ? 'd-block'
                : 'd-none'
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                howToArticleVideoIsComplete && saveArticlesIsComplete
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Save Your Favorite Articles</label>
              <p>
                Which articles are you most interested in? Peruse your
                subscription and use the “star” icon to save your favorites.
              </p>
              <div
                class="tl-hidden"
                v-bind:class="
                  howToArticleVideoIsComplete && saveArticlesIsComplete
                    ? 'tl-complete'
                    : ''
                "
              >
                <p
                  v-bind:class="
                    howToArticleVideoIsComplete && saveArticlesIsComplete
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="downloadAppIsHidden || download_app ? 'd-block' : ''"
          >
            <div
              class="trial-box"
              v-bind:class="
                downloadAppIsHidden || download_app ? 'tl-complete' : ''
              "
            >
              <label>Download the ITR onDemand App</label>
              <p>
                Ready to make the most of your subscription, anywhere and at any
                time? Download our app on your smart device to get started.
              </p>
              <div
                class="tl-hidden"
                v-bind:class="
                  downloadAppIsHidden || download_app ? 'tl-complete' : ''
                "
              >
                <p
                  v-bind:class="
                    downloadAppIsHidden || download_app ? 'tl-completed' : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              howToNotificationsVideoIsComplete && getNotificationsIsComplete
                ? 'd-block'
                : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                howToNotificationsVideoIsComplete && getNotificationsIsComplete
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Sign up for Notifications</label>
              <p>
                Don’t miss out on updates for your favorite articles - use the
                “bell” icon to receive notifications when specific articles are
                updated.
              </p>
              <div
                class="tl-hidden"
                v-bind:class="
                  howToNotificationsVideoIsComplete &&
                  getNotificationsIsComplete
                    ? 'tl-complete'
                    : ''
                "
              >
                <p
                  v-bind:class="
                    howToNotificationsVideoIsComplete &&
                    getNotificationsIsComplete
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              (coreClicked || core_dashboard) &&
              (financialClicked || financial_dashboard) &&
              (constructionClicked || construction_dashboard) &&
              (manufacturingClicked || manufacturing_dashboard)
                ? 'd-block'
                : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                (coreClicked || core_dashboard) &&
                (financialClicked || financial_dashboard) &&
                (constructionClicked || construction_dashboard) &&
                (manufacturingClicked || manufacturing_dashboard)
                  ? 'tl-complete'
                  : ''
              "
            >
              <label>Review Core Dashboards</label>
              <p>
                Need a quick overview of industry trends over the next three
                years? Our “at-a-glance” tables for each major sector feature
                economic insights and Business Cycle Phase projections for the
                near future.
              </p>
              <div class="tl-complete">
                <p
                  v-bind:class="
                    (coreClicked || core_dashboard) &&
                    (financialClicked || financial_dashboard) &&
                    (constructionClicked || construction_dashboard) &&
                    (manufacturingClicked || manufacturing_dashboard)
                      ? 'tl-completed'
                      : ''
                  "
                >
                  ✔ You completed this task!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 trial-dummy-spacer">
        <div
          class="trial-help-box"
          v-bind:class="
            (bookWalkthroughIsHidden &&
              reviewMethodologyIsHidden &&
              viewTutorialVideoIsHidden &&
              howToArticleVideoIsComplete &&
              saveArticlesIsComplete &&
              downloadAppIsHidden &&
              howToNotificationsVideoIsComplete &&
              getNotificationsIsComplete) ||
            (book_walkthrough &&
              review_methodology &&
              view_tutorial_video &&
              howToArticleVideoIsComplete &&
              saveArticlesIsComplete &&
              download_app &&
              howToNotificationsVideoIsComplete &&
              getNotificationsIsComplete)
              ? ''
              : 'invisible'
          "
        >
          <img src="/images/FAQ.png" alt="Help" class="trial-faq" />
          <p class="trial-help-text">Stuck? Need help?</p>
          <p>
            <a href="https://faq.itreconomics.com/en/trends-report">
              Click here
            </a>
            to check out our Trends Report™ FAQ.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'TrialListComponent',
    props: { 
      remaining_days: {
        type: Number,
        required: true,
      },
      book_walkthrough: {
        type: Boolean,
        required: true,
      },
      review_methodology: {
        type: Boolean,
        required: true,
      },
      view_tutorial_video: {
        type: Boolean,
        required: true,
      },
      save_your_fav_articles: {
        type: Boolean,
        required: true,
      },
      how_to_article_video: {
        type: Boolean,
        required: true,
      },
      how_to_notification_video: {
        type: Boolean,
        required: true,
      },
      download_app: {
        type: Boolean,
        required: true,
      },
      get_notifications: {
        type: Boolean,
        required: true,
      },
      product_id: {
        type: Number,
        required: true,
      },
      core_dashboard: {
        type: Boolean,
        required: true,
      },
      financial_dashboard: {
        type: Boolean,
        required: true,
      },
      construction_dashboard: {
        type: Boolean,
        required: true,
      },
      manufacturing_dashboard: {
        type: Boolean,
        required: true,
      },
      favorite_article: {
        type: String,
        required: true,
      },
      has_alert: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        bookWalkthroughIsHidden: false,
        reviewMethodologyIsHidden: false,
        viewTutorialVideoIsHidden: false,
        saveArticlesIsComplete: false,
        saveArticlesClicked: false,
        saveNotificationsClicked: false,
        howToArticleVideoIsComplete: false,
        downloadAppIsHidden: false,
        getNotificationsIsHidden: false,
        getNotificationsIsComplete: false,
        howToNotificationsVideoIsComplete: false,
        coreClicked: false,
        financialClicked: false,
        constructionClicked: false,
        manufacturingClicked: false,
        howToArticleVideoText: 'instructions',
        saveFavorite: 'save favorites',
        howToNotificationVideoText: 'instructions',
        saveNotification: 'sign up',
        trCoreDashboardText: 'core',
        trFinancialDashboardText: 'financial',
        trConstructionDashboardText: 'construction',
        trManufacturingDashboardText: 'manufacturing',
      };
    },
    mounted() {
      this.setData();
    },
    methods: {
      setData: function () {
        if (this.how_to_article_video) {
          this.howToArticleVideoText = '✔ instructions';
          this.howToArticleVideoIsComplete = true;
        }

        if (this.favorite_article) {
          this.saveFavorite = '✔ save favorites';
          this.saveArticlesIsComplete = true;
        }

        if (this.how_to_notification_video) {
          this.howToNotificationVideoText = '✔ instructions';
          this.howToNotificationsVideoIsComplete = true;
        }

        if (this.has_alert) {
          this.saveNotification = '✔ sign up';
          this.getNotificationsIsComplete = true;
        }

        if (this.core_dashboard) {
          this.trCoreDashboardText = '✔ core';
        }

        if (this.financial_dashboard) {
          this.trFinancialDashboardText = '✔ financial';
        }

        if (this.construction_dashboard) {
          this.trConstructionDashboardText = '✔ consctruction';
        }

        if (this.manufacturing_dashboard) {
          this.trManufacturingDashboardText = '✔ manufacturing';
        }
      },
      bookWalkthrough: function () {
        // window.open('https://meetings.hubspot.com/itranne/30-minute-trends-report-trial-tutorial','popup','width=800,height=600');
        window.open(
          'https://meetings.itreconomics.com/meetings/itr/trends-report-trial-call-default',
          'popup',
          'width=800,height=600'
        );
        var description = 'tr_book_walkthrough';
        var productId = this.product_id;
        this.bookWalkthroughIsHidden = true;

        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      reviewMethodology: function () {
        window.open(
          'https://itreconomics.com/methodology',
          'width=800,height=600'
        );
        var description = 'tr_review_methodology';
        var productId = this.product_id;
        this.reviewMethodologyIsHidden = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      viewTutorialVideo: function () {
        window.open('/trendsreport/video/5', 'popup', 'width=800,height=600');
        var description = 'view_tutorial_video';
        var productId = this.product_id;
        this.viewTutorialVideoIsHidden = true;

        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      saveArticles: function () {
        var description = 'save_your_fav_articles';
        var productId = this.product_id;
        this.saveArticlesClicked = true;
        this.saveFavorite = '✔ save favorites';
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      checkIfFavorite: function () {
        if (this.favorite_article !== null && this.favorite_article !== '') {
          this.saveArticlesIsComplete = true;
        }
      },
      articleHowToVideo: function () {
        var description = 'how_to_article_video';
        var productId = this.product_id;
        this.howToArticleVideoText = '✔ instructions';
        this.howToArticleVideoIsComplete = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      downloadApp: function () {
        var description = 'download_app';
        var productId = this.product_id;
        this.downloadAppIsHidden = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      getNotifications: function () {
        var description = 'get_notifications';
        var productId = this.product_id;
        this.saveNotificationsClicked = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      howToNotificationsVideo: function () {
        var description = 'how_to_notifications_video';
        var productId = this.product_id;
        this.howToNotificationVideoText = '✔ how-to video';
        this.howToNotificationsVideoIsComplete = true;

        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      trCoreDashboard: function () {
        window.open('/trendsreport/the-core-us-economy-at-a-glance/');
        var description = 'tr_core_dashboard';
        var productId = this.product_id;
        this.trCoreDashboardText = '✔ core';
        this.coreClicked = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      trFinancialDashboard: function () {
        window.open('/trendsreport/at-a-glance-financial/');
        var description = 'tr_financial_dashboard';
        var productId = this.product_id;
        this.trFinancialDashboardText = '✔ financial';
        this.financialClicked = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      trConstructionDashboard: function () {
        window.open('/trendsreport/at-a-glance-construction/');
        var description = 'tr_construction_dashboard';
        var productId = this.product_id;
        this.trConstructionDashboardText = '✔ construction';
        this.constructionClicked = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      trManufacturingDashboard: function () {
        window.open('/trendsreport/at-a-glance-manufacturing');
        var description = 'tr_manufacturing_dashboard';
        var productId = this.product_id;
        this.trManufacturingDashboardText = '✔ manufacturing';
        this.manufacturingClicked = true;
        axios
          .post('/trendsreport/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
    },
  };
</script>
